import { render } from "./SearchMedicalProvider.vue?vue&type=template&id=6ceadc78&scoped=true"
import script from "./SearchMedicalProvider.vue?vue&type=script&lang=js"
export * from "./SearchMedicalProvider.vue?vue&type=script&lang=js"

import "./SearchMedicalProvider.vue?vue&type=style&index=0&id=6ceadc78&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceadc78"]])

export default __exports__